import React from "react";

import github from "../assets/github.png";
import dsa from "../assets/DSA.png"
import styles from './statistics.module.css'


const SoftSkill = () => {
  const techs = [
    {
      id: 1,
      src: github,
      title: "Git collaboration",
      style: "shadow-gray-400",
    },
    {
        id: 2,
        src: dsa,
        title: "DSA",
        style: "shadow-violet-400",
      },
      {
        id: 3,
        src: "https://www.pngfind.com/pngs/m/69-697737_experienced-management-team-icon-hd-png-download.png",
        title: "Team Management",
        style: "shadow-gray-400",
      },
    
  ];

  return (
      <div className="max-w-screen-lg mx-auto p-4 flex flex-col justify-center w-full h-full text-white">
        <div >
            <div className={styles.stateHading}>
          <p className="text-4xl font-bold border-b-4 border-gray-500 p-2 inline">
            Softs Skill
          </p>
            </div>
            <div className={styles.stateHading}>
          <p className="py-6">These are the Soft-skills I've worked with and used them in my projects.</p>
          </div>
        </div>

        <div className="w-full grid grid-cols-2 sm:grid-cols-3 gap-8 text-center py-8 px-12 sm:px-0">
          {techs.map(({ id, src, title, style }) => (
            <div
              key={id}
              className={`shadow-md hover:scale-105 duration-500 py-2 rounded-lg ${style}`}
            >
              <img src={src} alt="" className="w-20 mx-auto" />
              <p className="mt-4">{title}</p>
            </div>
          ))}
        </div>
      </div>
  );
};

export default SoftSkill;
